import { render, staticRenderFns } from "./PresentationInstructorList.vue?vue&type=template&id=1906130e&scoped=true"
import script from "./PresentationInstructorList.vue?vue&type=script&lang=js"
export * from "./PresentationInstructorList.vue?vue&type=script&lang=js"
import style0 from "./PresentationInstructorList.vue?vue&type=style&index=0&id=1906130e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906130e",
  null
  
)

export default component.exports